// extracted by mini-css-extract-plugin
export default {"DisplayItem":"Ltxx2SHv_unPjh7tPqaE"};